export default {
  test: '测试i18n',
}
